import React from 'react';

import { getDayOfWeek } from '../../utils/map';
import LocationCard from './LocationCard';

export default function LocationList({ locations, className }) {
  const dayOfWeek = getDayOfWeek();

  return (
    <div className={className}>
      {!locations && <div>No Locations</div>}
      {locations &&
        locations.map((location) => (
          <LocationCard
            key={location.Site_ID}
            location={location}
            dayOfWeek={dayOfWeek}
          />
        ))}
    </div>
  );
}
